export default __webpack_public_path__ + "static/media/verdaz.46eec0f9.png";